<template>
  <div>
    <!-- <el-dialog :visible.sync="dialogVisible" width="35%" :show-close="true"	:close-on-click-modal="false"> -->

    <a-modal
      :visible="dialogVisible"
      :footer="null"
      @cancel="dialogVisible = false"
    >
      <div class="charge-field">
        <div class="charge-box">
          <div class="charge-title"><span>订单支付</span></div>

          <div class="order-info">
            <div class="order-tit">本次订单需充值金额</div>
            <div class="order-detail">
              <div class="order-name">
                订单号：
                <span class="high">{{ this.orderForm.serialNum }}</span>
              </div>

              <div class="charge-money">
                <em>￥</em
                ><span class="rechargemoney">{{
                  this.orderForm.amountFinally
                }}</span>
              </div>
            </div>
          </div>
          <div class="charge-info">
            <!---->
            <!-- <div class="charge-item">
              <ul class="charge-ctn charge-type paytype clear">
                <li has_spare="0"
                  onclick="window._czc &amp;&amp; window._czc.push(['_trackEvent','弹层支付页',`${vo.payment_name}`])"
                  class="type-item">
                  <div>
                    <div class="item-top"><i class="re-icon type1001"></i>
                      <span class="re-name"> 支付宝 </span>
                    </div>
                  </div>
                </li>
                <li has_spare="0"
                  onclick="window._czc &amp;&amp; window._czc.push(['_trackEvent','弹层支付页',`${vo.payment_name}`])"
                  class="type-item">
                  <div>
                    <div class="item-top"><i class="re-icon type2001"></i>
                      <span class="re-name"> 微信支付 </span>
                    </div>
                  </div>
                </li>
                <li has_spare="0"
                  onclick="window._czc &amp;&amp; window._czc.push(['_trackEvent','弹层支付页',`${vo.payment_name}`])"
                  class="type-item hover">
                  <div>
                    <div class="item-top"><i class="re-icon type1001 type10011"></i>
                      <span class="re-name"> 花呗支付 </span>
                    </div>
                  </div>
                </li>
              </ul>
            </div> -->
            <div class="charge-item">
              <!---->
              <div class="charge-ctn qrcode-ctn">
                <div id="qrcode" align="center">
                  <div id="qrcode" ref="qrCodeDiv"></div>
                </div>
              </div>
            </div>
            <div class="paid-tips">
              若您已支付成功，请点击
              <el-button type="text" @click="ConfirmPayment()" v-preventClick>
                我已支付
              </el-button>
            </div>
            <div class="warning-txt" style="text-align: center">
              温馨提示：如未及时到账，请联系客服
            </div>
          </div>
          <div class="bottom-tips">
            <div class="tips">
              严禁任何机构或个人利用收款码进行诈骗，如有发现请联系客服
            </div>
          </div>
        </div>
      </div>
    </a-modal>

    <van-dialog
      title="支付提示"
      v-model="dialogPayTipVisible"
      show-cancel-button
      confirmButtonText="我已支付"
      cancelButtonText="取消支付"
      @confirm="ConfirmPayment()"
      :before-close="newGroupBefColse"
    >
      <div style="padding: 20px; text-align: center">请确认支付信息</div>
    </van-dialog>
  </div>
</template>

<script>
import { pay, statusPaid } from "@/api/order";

import { onlinePayment } from "@/api/pay";

import { Toast } from "vant";
import QRCode from "qrcodejs2";

export default {
  name: "Payment",
  props: {
    //支付信息
    payConfig: {
      type: Object,
    },
    orderId: {
      type: Number, //订单Id
      default: undefined,
    },

    orderParams: {
      type: Array, //订单参数
      default: undefined,
    },

    deliveryRemark: {
      type: String, //订单备注
      default: undefined,
    },

    //收货地址Id
    deliveryId: {
      type: Number,
      default: undefined,
    },

    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogPayTipVisible: false,
      dialogVisible: false,
      orderForm: {},
    };
  },
  methods: {
    newGroupBefColse(action, done) {
      if (action == "confirm") {
        done(false);
      } else {
        done();
      }
    },

    //订单支付
    toPayment() {
      let data = {
        id: this.orderId,
        payId: this.payConfig.payId,
        orderParams: this.orderParams,
        deliveryRemark: this.deliveryRemark,
        paymentMethod: "balance",
      };

      //余额支付
      if (this.payConfig === "balance") {
        new Promise((resolve, rejust) => {
          pay(data)
            .then((res) => {
              if (res.status == 0) {
                Toast.success({
                  message: "付款成功",
                });

                // 付款成功处理
                setTimeout(() => {
                  if (this.isMobile) {
                    this.$router.push({ path: "order" });
                  } else {
                    this.$router.push({ path: "porder" });
                  }
                }, 300);
              }
              resolve();
            })
            .catch((error) => {
              rejust(error);
            });
        });
      } else {
        /**
         * 在线支付
         */
        onlinePayment(data)
          .then((res) => {
            let returnType = res.result.returnType;

            let returnUrl = res.result.returnUrl;

            //1:跳转支付
            if (returnType == 1) {
              // window.open(returnUrl, "_blank");
              setTimeout(() => window.open(returnUrl, "_blank"));
            }

            //二维码扫码支付
            if (returnType == 2) {
              this.dialogVisible = true;
              this.GenerateQRCode(returnUrl);
            }

            this.orderForm = res.result.orderForm;
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            // 无论成功失败都会执行的逻辑
          });
      }
    },

    /**
     * 确认支付
     */
    ConfirmPayment() {
      this.loopOrderState();
    },

    // 生成二维码
    GenerateQRCode(qrCode) {
      //生成之前清除二维码
      this.delQrcode();
      var that = this;
      setTimeout(() => {
        new QRCode(that.$refs.qrCodeDiv, {
          text: qrCode,
          width: 200,
          height: 200,
          colorDark: "#333333", //二维码颜色
          colorLight: "#ffffff", //二维码背景色
          correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
        });
      }, 0);
    },

    //查询付款状态
    loopOrderState() {
      new Promise((resolve, rejust) => {
        statusPaid({ id: this.orderId })
          .then((res) => {
            if (res.result == 1) {
              Toast.success({
                message: "付款成功",
              });
              // 付款成功处理
              setTimeout(() => {
                if (this.isMobile) {
                  this.$router.push({ path: "order" });
                } else {
                  this.$router.push({ path: "porder" });
                }
              }, 300);
            }
            resolve();
          })
          .catch((error) => {
            rejust(error);
          });
      });
    },

    // 清空二维码,避免生成多个二维码
    delQrcode() {
      setTimeout(() => {
        this.$refs.qrCodeDiv.innerHTML = "";
      }, 0);
    },
  },
};
</script>

<style>
.section .zf_order {
  margin: 18px auto 0;
  /* padding-top: 38px; */
  background: #fff;
  -webkit-box-shadow: 0 3px 3px 0 hsla(0, 0%, 92.5%, 0.44);
  box-shadow: 0 3px 3px 0 hsla(0, 0%, 92.5%, 0.44);
  border-radius: 12px;
  text-align: center;
  padding-bottom: 38px;
}

.section .con {
  margin: 3px auto 0;
  padding-top: 10px;
  background: #fff;
  -webkit-box-shadow: 0 3px 3px 0 hsla(0, 0%, 92.5%, 0.44);
  box-shadow: 0 3px 3px 0 hsla(0, 0%, 92.5%, 0.44);
  border-radius: 12px;
  text-align: center;
  padding-bottom: 38px;
}

.section .zf_order .col-12 .order {
  width: 340px;
  margin: 15px auto 21px;
  background: #fbfbfb;
  border-radius: 6px;
  line-height: 42px;
  text-align: center;
}

.section .zf_order .col-12 .order span:first-child {
  color: #999;
  font-size: 15px;
  margin-left: 14px;
}

.section .zf_order .col-12 .order span:nth-child(2) {
  color: #3259ff;
  font-size: 13px;
  float: right;
  margin-right: 21px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  cursor: pointer;
}

.goods_name {
  font-weight: 500;
  font-size: 12px;
  color: #999;
  border-bottom: 1px solid #f5f5f5;
  padding-bottom: 20px;
}

.goods_name span:nth-child(2) {
  margin-left: 14px;
}

.yuanmoney {
  width: 340px;
  margin: 15px auto 21px;
  background: #fbfbfb;
  border-radius: 6px;
  line-height: 42px;
  text-align: left;
}

.yuanmoney span:nth-child(2) {
  color: #3259ff;
  font-size: 13px;
  float: right;
  margin-right: 21px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  cursor: pointer;
}

.pay_type {
  width: 100%;
  text-align: center;
  margin-top: 10px;
}

.pay_type img {
  display: inline-block;
  vertical-align: middle;
  width: 23px;
}

.pay_type span {
  font-weight: 700;
  font-size: 14px;
  color: #545454;
  margin-left: 3px;
  display: inline-block;
  vertical-align: middle;
}

.code_cs,
.code {
  height: 208px;
  background: #fbfbfb;
  position: relative;
  width: 208px;
  margin-top: 10px;
  margin-left: -104px;
  left: 50%;
}

.code_cs {
  height: 208px;
  background: #ffffff;
}

.code_cs img {
  position: absolute;
  width: 49px;
  left: 50%;
  margin-left: -25px;
  top: 50%;
  margin-top: -25px;
  padding: 10px;
}

.code {
  border: 5px solid #d8d1d1;
  border-radius: 5px;
  position: relative;
  width: 208px;
  margin-top: 10px;
  margin-left: -104px;
  left: 50%;
  display: block;
  padding: 3px;
}

.price {
  color: #386cfa;
  width: 100%;
  text-align: center;
  top: 65px;
}

.price span:first-child {
  font-size: 28px;
}

.price span {
  font-weight: 700;
}

.price span:nth-child(2) {
  font-size: 17px;
}

.price span {
  font-weight: 700;
}

.shanxinzha {
  margin-top: 32px;
  width: 100%;
  text-align: center;
}

.shanxinzha img {
  display: inline-block;
  vertical-align: middle;
  width: 26px;
  /* -webkit-animation: xuanzhuan 0.8s linear infinite; */
}

.shanxinzha span {
  color: #999;
  font-size: 14px;
  font-weight: 400;
  margin-left: 5px;
}

.shanxinzha span p {
  display: inline-block;
  color: #386cfa;
}

.section--last {
  margin-bottom: 20px;
}

/* 新支付页面 */
.qr-order-content {
  width: 100%;
  background-color: #f5f5f5;
  overflow: hidden;
  padding-top: 23px;
}

.qr-order-content .bt {
  width: 100%;
  height: 64px;
  background-color: #eaf2ff;
  color: #0a72ff;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  line-height: 64px;
}

.qr-order-content .box1 {
  width: 100%;
  background-color: #fff;
  overflow: hidden;
  /* margin-bottom: 80px;
  padding-bottom: 80px; */
  margin: 20px 0 40px;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 5px 10px rgb(0 0 0/5%);
  display: flex;
}

.qr-order-content .box1-1 {
  /* width: 644px; */
  margin: 0 auto;
  /* margin-top: 42px; */
  overflow: hidden;
  background-color: #f5f5f5;
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.qr-order-content .box1-1 ul li {
  line-height: 35px;
  font-size: 16px;
  color: #333333;
}

.qr-order-content .box1-2 {
  /* width: 644px; */
  margin: 0 auto;
  margin-top: 42px;
  overflow: hidden;
}

.qr-order-content .box1-2 ul {
  width: 100%;
}

.qr-order-content .box1-2 ul li {
  float: left;
  width: 131px;
  height: 42px;
  margin-right: 6px;
  border: 1px solid #d6d6d6;
  border-radius: 3px;
  font-size: 14px;
  color: #333333;
  line-height: 42px;
  margin-top: 30px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.box1-3 {
  /* width: 644px; */
  overflow: hidden;
  margin: 0 auto;
  /* margin-top: 50px; */
}

.qr-order-content .box1-1 ul li {
  margin-bottom: 10px;
  list-style: none;
}

.qr-order-content .box1-1 ul li span.label {
  display: inline-block;
  width: 90px;
  font-weight: bold;
  color: #333;
  font-size: 16px;
}

.qr-order-content .box1-1 ul li span.value {
  color: #5e72e4;
  font-size: 16px;
  font-weight: bold;
}

.order-content {
  width: 100%;
  margin-top: 20px;
  background: #f9f9fa;
}

.order-content .goods-detail {
  padding: 5px;
  width: 100%;
  border-radius: 20px;
  background-color: #fff;
}

.order-content .goods-detail .add-info-title,
.order-content .goods-detail .by-info-title,
.order-content .goods-detail .title {
  color: #303133;
  padding: 16px;
  margin: 0 10px;
  font-weight: 700;
  color: #333;
  font-size: 18px;
  position: relative;
  margin-left: 20px;
}

.order-content .goods-detail .add-info-title:before,
.order-content .goods-detail .by-info-title:before,
.order-content .goods-detail .title:before {
  content: "";
  height: 20px;
  width: 5px;
  background: #2b6fff;
  display: block;
  position: absolute;
  top: 50%;
  left: 1px;
  border-radius: 0.18rem;
  transform: translateY(-50%);
}

.order-content .goods-detail .qr-order-content {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  height: 180px;
  margin: 0 auto;
  width: 98%;
  padding: 0 0.56rem;
  background: #f9f9fa;
  border-radius: 0.18rem;
}

.order-content .goods-detail .qr-order-content span.goods-type {
  position: absolute;
  top: 0;
  right: 0;
  width: 160px;
  height: 40px;
  background: #1890ff;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  border-radius: 0 10px 0 10px;
}

.order-content .goods-detail .qr-order-content .el-image {
  width: 150px;
  height: 150px;
  border-radius: 10px;
  margin-right: 10px;
}

.order-content .goods-detail .qr-order-content .row-content {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.order-content .goods-detail .qr-order-content .conter {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 0.9rem;
  border-radius: 0.1rem;
  border: 1px solid #dcdfe6;
  overflow: hidden;
}

.order-content .goods-detail .qr-order-content .conter:hover {
  border-color: #1890ff;
}

.order-content .goods-detail .qr-order-content .conter .conter-input {
  display: block;
  height: 100%;
  width: 2.5rem;
  font-size: var(--sizeM, 0.25rem);
  outline: none;
  border: none;
  text-align: center;
  padding: 0 !important;
  margin: 0 !important;
}

.order-content .goods-detail .qr-order-content .conter .icon {
  width: 0.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ddd;
  height: 100%;
  cursor: pointer;
}

.order-content .goods-detail .qr-order-content .conter .icon:hover {
  color: #1890ff;
}

.order-content .goods-detail .el-form {
  width: 100%;
  margin: 0 auto;
  border-radius: 0.1rem;
}

.order-content .goods-detail .el-form .el-form-item .tips {
  font-size: var(--sizeXL, 0.35rem);
  color: grey;
  margin: 0 5px;
}

.order-content .goods-detail .add-info-content {
  display: flex;
}

.order-content .goods-detail .add-info-content .el-form {
  padding-top: 4px;
}

.order-content .goods-detail .by-info-content {
  width: 98%;
  padding: 0.36rem;
  padding-left: 0;
  margin: 0 auto;
  /* background-color: #fbfbfb; */
  display: flex;
  justify-content: space-between;
  /* border-top: 0.018rem solid #ddd; */
}

.order-content .goods-detail .by-info-content .pay-computed {
  width: 20%;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666;
}

.order-content .goods-detail .by-info-content .pay-computed .el-row {
  margin: 15px auto;
}

.order-content .goods-detail .by-info-content .pay-computed .el-row .sub-btn {
  width: 4.44rem;
  height: 0.89rem;
  background: #1890ff;
  border-radius: 0.1rem;
  font-size: var(--sizeXL, 0.35rem);
}

.order-content
  .goods-detail
  .by-info-content
  .pay-computed
  .el-row:first-child {
  color: #999;
  text-decoration: line-through;
}

.order-content .goods-detail .by-info-content .by-info-content-input {
  display: flex;
  font-size: var(--sizeM, 0.25rem);
  margin: 0 0.18rem;
}

.order-content .goods-detail .choose-pay {
  display: flex;
  align-items: center;
  padding: 22px 15px;
  gap: 16px;
}

.order-content .goods-detail .choose-pay p {
  font-size: 14px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #333;
}

.order-content .goods-detail .choose-pay .choose-pay-item {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 14px;
}

.order-content .goods-detail .choose-pay .choose-pay-item .pay-item {
  display: flex;
  align-items: center;
  border-radius: 10px;
  border: 1px solid #e6e6e6;
  width: 160px;
  height: 50px;
  justify-content: center;
  gap: 10px;
  cursor: pointer;
}

.order-content .goods-detail .choose-pay .choose-pay-item .pay-item .svg {
  width: 26px;
  height: 26px;
}

.order-content .goods-detail .choose-pay .choose-pay-item .pay-item p {
  font-size: 16px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #333;
}

.order-content .goods-detail .choose-pay .choose-pay-item .active {
  border-color: #1890ff;
}

.order-content .goods-detail .choose-pay .choose-pay-item label {
  white-space: nowrap;
}

.order-content .goods-detail .choose-pay .choose-pay-item .pass-box {
  width: 400px;
}

.order_spacing {
  margin-top: 20px;
}

/* 新的 */

.charge-field .charge-box {
  position: relative;
  overflow: hidden;
  border-radius: 2px;
  margin: 0 auto;
  top: 50%;
  background-color: #fff;
  /* -webkit-box-shadow: 0px 18px 40px 0px rgba(51, 51, 51, .18); */
  /* box-shadow: 0 18px 40px #3333332e; */
  padding-top: 20px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  line-height: 1;
}

.charge-field .charge-box .charge-title {
  font-size: 18px;
  font-weight: 700;
  color: #4d4d4d;
  position: relative;
  text-align: center;
  margin-bottom: 24px;
  line-height: 24px;
}

.charge-field .charge-box .charge-title .close-btn {
  position: absolute;
  width: 10px;
  height: 10px;
  top: -18px;
  right: 10px;
  cursor: pointer;
  padding: 10px;
  background: url(https://zuhaowan.zuhaowan.com/static/www/zhw-pc-rent/img/order-pop-close.a86bce47.png)
    no-repeat;
  background-position: center center;
}

.charge-field .charge-box .order-info {
  padding: 0 20px;
}

.charge-field .charge-box .order-info .order-tit {
  margin-bottom: 16px;
  font-size: 12px;
  display: none;
}

.charge-field .charge-box .order-info .order-detail {
  background-color: #f7f8fc;
  padding: 16px 0;
  text-align: center;
}

.order-detail .order-name {
  font-size: 14px;
  color: #4d4d4d;
  line-height: 24px;
}

.order-detail .order-name .high {
  color: #ff893d;
}

.charge-field .charge-box .order-info .order-detail .money-item {
  display: inline-block;
  line-height: 16px;
  margin-right: 24px;
  font-size: 12px;
  color: #4d4d4d;
}

.charge-field .charge-box .order-info .order-detail .money-item:last-child {
  margin-right: 0;
}

.charge-field .charge-box .order-info .order-detail .charge-money {
  font-size: 32px;
  color: #ff3d3d;
  font-weight: 700;
  height: 24px;
  line-height: 24px;
  margin: 13px 0 16px;
}

.charge-field .charge-box .order-info .order-detail .charge-money em {
  font-size: 16px;
  font-style: normal;
}

.charge-field .charge-box .order-info .order-tips {
  margin-top: 12px;
  text-align: left;
  font-size: 12px;
  color: #555;
}

.charge-field .charge-box .order-info .order-tips em {
  font-size: 14px;
  color: #fc3737;
  font-style: normal;
}

.charge-field .charge-box .charge-info {
  margin-top: 30px;
}

.charge-field .charge-box .charge-info .charge-label {
  color: #888;
  width: 80px;
}

.charge-field .charge-box .charge-info .balance-ctn {
  font-size: 14px;
}

.charge-field .charge-box .charge-info .balance {
  color: #fc3737;
  font-size: 16px;
}

.charge-field .charge-box .charge-info .qrcode-box {
  width: 170px;
  height: 170px;
  border: 1px solid #e6e6e6;
  position: relative;
  padding: 4px;
  box-sizing: border-box;
  margin: 12px auto 0;
}

.charge-field .charge-box .charge-info .msg_panel {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 150px;
  margin-left: -75px;
  line-height: 20px;
  background: #bbb;
  color: #fff;
  text-align: center;
  padding: 3px 0;
  transform: translateY(-50%);
}

.charge-field .charge-box .charge-info .qrcode-box .qrcode {
  width: 100%;
  height: 100%;
  vertical-align: top;
}

.charge-field .charge-box .charge-info .tips-wx {
  position: relative;
  color: #fc3737;
  cursor: pointer;
  text-align: center;
  margin-top: 9px;
}

.charge-field .charge-box .charge-info .warning-txt {
  height: 32px;
  font-size: 12px;
  color: #999;
  line-height: 16px;
  margin: 12px 20px 0;
}

.charge-field .charge-box .charge-info .warning-txt .high {
  color: #262626;
}

.charge-field .charge-box .charge-info .refresh-btn {
  color: #fc3737;
}

.charge-field .charge-box .charge-info .refresh-wxtips {
  font-size: 12px;
  line-height: 24px;
  cursor: auto;
}

.charge-field .charge-box .charge-info .tips-txt {
  line-height: 16px;
  font-size: 12px;
  color: #555;
}

.charge-field .charge-box .charge-info .tips-wx:hover .tipx-txt {
  display: block;
}

.charge-field .tips-wx .tipx-txt {
  width: 150px;
  position: absolute;
  left: -32px;
  top: 37px;
  border: 1px solid #e9e9e9;
  padding: 5px;
  font-size: 12px;
  color: #666;
  line-height: 16px;
  border-radius: 3px;
  text-align: justify;
  box-shadow: 0 0 10px #e9e9e9;
}

.charge-field .tips-wx .tipx-txt:before {
  content: "";
  position: absolute;
  width: 10px;
  height: 10px;
  background: #fff;
  transform: rotate(45deg);
  left: 72px;
  top: -6px;
  border: 1px solid #e9e9e9;
  border-bottom: 0px;
  border-right: 0px;
}

.charge-field .charge-box .charge-info .charge-type {
  flex: 1;
}

.charge-field .charge-box .charge-info .charge-type .type-item {
  width: 116px;
  height: 40px;
  margin: 0 0 20px 20px;
  border-radius: 4px;
  border: 1px solid #e6e6e6;
  user-select: none;
  padding: 0 8px;
  cursor: pointer;
  list-style: none;
  display: inline-flex;
  align-items: center;
  position: relative;
  box-sizing: border-box;
}

.charge-field .charge-box .charge-info .charge-type .re-icon {
  width: 32px;
  height: 32px;
  display: inline-block;
  margin-right: 4px;
}

.charge-field .charge-box .charge-info .charge-type .hover {
  border: solid 1px #fc3737;
}

.charge-field .charge-box .charge-info .charge-type .hover:after {
  position: absolute;
  content: "";
  width: 16px;
  height: 16px;
  bottom: 0;
  right: 0;
  background-image: url(data:image/png;base64,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);
  background-repeat: no-repeat;
  background-position: 0 0;
}

.charge-field .charge-box .charge-tips {
  font-size: 12px;
  color: #fc3737;
  margin-top: 22px;
}

.charge-field .charge-box .bottom-tips {
  font-size: 12px;
  margin-top: 24px;
  color: #ff893d;
  line-height: 16px;
  background: #fff6ee;
  text-align: center;
  padding: 8px 0;
}

.charge-field .charge-box .bottom-tips .high {
  font-weight: 700;
}

.charge-field .charge-box .bottom-tips .leftmoney {
  color: #fc3737;
}

.charge-field .charge-box .charge-info .charge-type .type-item > div {
  overflow: hidden;
}

.charge-field .charge-box .charge-info .charge-type .type1001 {
  background-image: url(//zuhaowan.zuhaowan.com/static/www/dofunPay/img/icon_zfb.png);
  background-size: 34px 34px;
}

.charge-field .charge-box .charge-info .charge-type .type2001 {
  background-image: url(//zuhaowan.zuhaowan.com/static/www/dofunPay/img/icon_wx.png);
  background-size: 34px 34px;
}

.charge-field .charge-box .charge-info .charge-type .type6001 {
  background-image: url(//zuhaowan.zuhaowan.com/static/www/dofunPay/img/icon_ysf.png);
  background-size: 34px 34px;
}

.charge-field .charge-box .charge-info .charge-type .type10011 {
  background-image: url(//zuhaowan.zuhaowan.com/static/www/dofunPay/img/icon_hb.png);
  background-size: 34px 34px;
}

.charge-field .charge-box .charge-info .charge-type .item-top {
  display: flex;
  align-items: center;
}

.charge-field .charge-box .charge-info .charge-type .re-name {
  font-size: 14px;
  font-family: MicrosoftYaHei;
  color: #262626;
  line-height: 19px;
}

.charge-field .charge-box .charge-info .charge-type .re-name > span {
  font-size: 12px;
  color: #fc3737;
  background: #ffeeee;
  border-radius: 10px 10px 10px 0;
  height: 20px;
  line-height: 20px;
  padding: 0 6px;
  margin-left: 6px;
}

.charge-field .charge-box .charge-info .charge-type .re-tip {
  height: 16px;
  line-height: 16px;
  font-size: 12px;
  color: #999;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-left: 4px;
}

.paid-tips {
  font-size: 12px;
  color: #4d4d4d;
  line-height: 16px;
  text-align: center;
  margin-top: 16px;
}

.paid-tips .paid-btn {
  cursor: pointer;
  color: #ff372b;
}

.layer-anim111 {
  margin: auto;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 19991017;
  width: 500px;
  height: 400px;
}

.pay_content {
  width: 90%;
  height: 290px;
  margin: 0 auto;
}

.pay_content_left {
  width: 43%;
  float: left;
}

.pay_content_right {
  width: 55%;
  float: right;
  margin-top: 20px;
}

.pay_ewm {
  width: 100%;
  height: 200px;
  text-align: center;
  line-height: 200px;
  border: 1px solid #f6f6f6;
}

.pay_ewm img {
  max-width: 100%;
  max-height: 200px;
}

.pay_xz {
  background: #bdbdbd;
  height: 40px;
  width: 100%;
  line-height: 40px;
  text-align: center;
  color: #fff;
  font-weight: 700;
}

.pay_xz div {
  width: 50%;
  float: left;
  cursor: pointer;
}

.p_active_xz {
  background: #02a9e9;
}

.pay_content_right p {
  line-height: 50px;
  padding-left: 10px;
}

.pay_content_right p span {
  float: right;
  padding-right: 10px;
  font-size: 20px;
  color: red;
}

.pay_content_right p em {
  font-style: normal;
  color: red;
}

.pay_zzc {
  position: fixed;
  z-index: 998;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: #0000004d;
}
</style>
